<template>
    <div class="edit-account">
        <div v-if="statusUpdateMessage" class="success td-banner dismissible">
            <icon name="faCircleCheck" type="solid"></icon>
            <p>{{statusUpdateMessage}}</p>
            <icon name="faXmark" type="solid" @click="statusUpdateMessage = ''"></icon>
        </div>

        <div class="edit-account-heading">
            <div>
                <h1 class="td-h2 mt-0">Edit Account {{ account.ain }}</h1>
            </div>

        </div>

        <div class="edit-account-cards">
            <div class="td-card border rounded">
                <p>
                    <strong class="mr-1">Name:</strong>
                </p>
                <p>
                    <strong class="mr-1">Email:</strong>
                </p>
                <p>
                    <strong class="mr-1">Office Number:</strong>
                </p>
                <p>
                    <strong class="mr-1">Fax Number:</strong>
                </p>
                <p>
                    <strong class="mr-1">Website:</strong>
                </p>
            </div>
            <div class="td-card border rounded">
                <p>
                    <strong class="mr-1">Status:</strong>
                </p>
                <p>
                    <strong class="mr-1">Account Type:</strong>
                </p>
                <p>
                    <strong class="mr-1">Parent Account:</strong>
                </p>
                <p>
                    <strong class="mr-1">Dealer Network:</strong>
                </p>
                <p>
                    <strong class="mr-1">Sites:</strong>
                </p>
            </div>
            <div class="td-card border rounded">
                <p>
                    <strong class="mr-1">Original Site:</strong>
                </p>
                <p>
                    <strong class="mr-1">Fleet Size:</strong>
                </p>
                <p>
                    <strong class="mr-1">DOT Number:</strong>
                </p>
                <p>
                    <strong class="mr-1">IFTA Number:</strong>
                </p>
                <p>
                    <strong class="mr-1">Do Not Market:</strong>
                </p>
            </div>
            <div class="small-col">
                <div class="td-card border rounded" style="display: grid; grid-auto-rows: 1fr">
                    <div class="td-text-center">
                        <h4 class="card-heading">
                            Customer Service Contact:
                            <span>
                                <icon class="ml-1 td-text-primary" name="faEdit" type="solid"></icon>
                            </span>
                        </h4>
                        {{ account.csrName }}
                    </div>
                </div>
                <div class="td-card border rounded">
                    <div class="td-text-center">
                        <h4 class="card-heading">
                            Address:
                            <span>
                                <icon class="ml-1 td-text-primary" name="faEdit" type="solid"></icon>
                            </span>
                        </h4>
                        <div v-if="account.info.address">
                            {{ account.info.address.line1 }}<br />
                            {{ account.info.address.city }}, {{ account.info.address.regionCode }} {{ account.info.address.countryCode }}
                            {{ account.info.address.postalCode }}
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="footer-card td-card border rounded mt-2">
            <div>
                <p><strong>Created:</strong></p>
            </div>
            <div>
                <p><strong>Last Modified:</strong></p>

            </div>
            <div>
                <p><strong>Last Verified:</strong></p>

            </div>
        </div>
    </div>
</template>
<script>
    import script from './EditAccountAdmin';
    export default script;</script>

<style lang="less">
    @import "./EditAccountAdmin.less";
</style>

